import { useMemo } from "react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { ProductsListView } from "~/pages/Brand/Products/List/constants.ts"

export type StandardHeaders = {
  name: string
  certificates: LibraryResponses.StandardsCertificate[]
}

export function useHeaders(
  products: LibraryResponses.Product[],
  view: ProductsListView,
  standardIdFilter?: number
) {
  const standardHeaders = useMemo(() => {
    if (view === "certificates") {
      const flatStandards = products.flatMap(
        (product) => product.standards ?? []
      )

      return [...new Set(flatStandards.map((standard) => standard.name))]
        .flatMap(
          (name) =>
            flatStandards.find((standard) => standard.name == name) ?? []
        )
        .filter((standard) => {
          if (standardIdFilter) {
            return standard.id === standardIdFilter
          }
          return true
        })
    }
    return []
  }, [products, view, standardIdFilter])

  const customHeaders = useMemo(() => {
    if (view === "customFields") {
      const customHeader: Record<string, string> = {}
      for (const p of products) {
        const newCustomHeader: Record<string, string> = Object.assign(
          {},
          ...Object.keys(p.flattenCustomFields).map((key) => ({ [key]: key }))
        )
        Object.assign(customHeader, newCustomHeader)
      }
      return customHeader
    }
    return []
  }, [products, view])

  return { standardHeaders, customHeaders }
}
